import { defaultLocale, isSupportedLocale, type Locale } from '@/config/i18n/locales';
import { extractIdFromUrl } from '@/common/helpers/extractIdFromUrl';

export type ParsedHousingDetailPath = {
  locale: Locale;
  housingId: string;
};

export const parseHousingDetailPath = (pathname: string): ParsedHousingDetailPath | null => {
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length < 2) return null;

  let locale: Locale = defaultLocale;
  let housingIndex = 0;

  if (isSupportedLocale(segments[0])) {
    locale = segments[0];
    housingIndex = 1;
  }

  if (segments[housingIndex] !== 'housing') return null;

  const slug = segments[housingIndex + 1];
  if (!slug) return null;

  const housingId = extractIdFromUrl(slug);
  if (!housingId) return null;

  return { locale, housingId };
};
